<template>
  <div class="doctorManageDel">
    <el-dialog
      title="系统提醒"
      :visible.sync="open"
      :close-on-click-modal="true"
      width="480px"
    >
      <div class="del-box">
        <p>
          确定要删除&nbsp;<span class="name">{{ delObj.name }}</span
          >&nbsp;医生？
        </p>
        <p>删除后绑定的患者数据将无法追回！请谨慎操作！</p>
      </div>
      <div class="btn-box">
        <el-button
          @click="confirmDelete"
          class="btn"
          style="background-color: red;color: #fff;"
          >确认删除</el-button
        >
        <el-button @click="cancel" class="btn">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "doctorManageDel",
  props: {
    value: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    delObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    open: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
  },
  methods: {
    cancel() {
      this.open = false;
    },
    confirmDelete() {
        console.log(this.delObj.id);
        
      this.$del(`docmanage/delete/${this.delObj.id}`).then((res) => {
        if (res) {
          console.log(res);
        //   this.get_list();
          this.$emit('delGetList')
          this.open = false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.doctorManageDel {
  .btn-box {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #ebecf0;
    .btn {
      width: 90px;
      height: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .del-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    .name {
      font-weight: 700;
    }
  }
}
::v-deep .el-dialog__header {
  background-color: red;
  .el-dialog__title {
    color: #fff;
  }
  .el-dialog__headerbtn {
    font-size: 20px;
    .el-dialog__close {
      color: #fff;
    }
  }
}
</style>
